(() => {
class V2MenuAccordions extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      if (event.target.closest('summary')) event.stopPropagation();
    }, true);
    this.addEventListener('toggle', (event) => {
      if (event.target instanceof HTMLDetailsElement) {
        event.target.querySelector('summary').setAttribute('aria-expanded', event.target.open);
      }
    }, true);
    this.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') return;
      const details = event.target.closest('details[open]');
      if (!details || !this.contains(details)) return;
      event.stopPropagation();
      details.open = false;
      const summary = details.querySelector('summary');
      summary.setAttribute('aria-expanded', 'false');
      summary.focus();
    }, true);
  }

  connectedCallback() {
    this.drawer = this.closest('header-drawer');
    this.rootDetails = this.drawer.querySelector('details');
    this.handleTab = (event) => {
      if (event.key !== 'Tab' || !this.rootDetails.open) return;
      const visibleControls = getFocusableElements(this.rootDetails).filter((element) =>
        element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' &&
        !element.closest('details:not([open]) > :not(summary)')
      );
      const first = visibleControls[0];
      const last = visibleControls[visibleControls.length - 1];
      const target = event.shiftKey && event.target === first ? last :
        !event.shiftKey && event.target === last ? first : null;
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      target.focus();
    };
    this.handleResize = (event) => {
      if (this.rootDetails.open && getComputedStyle(this.drawer).display === 'none') {
        this.drawer.closeMenuDrawer(event, this.rootDetails.querySelector('summary'));
      }
    };
    this.drawer.addEventListener('keydown', this.handleTab, true);
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    this.drawer.removeEventListener('keydown', this.handleTab, true);
    window.removeEventListener('resize', this.handleResize);
  }
}

if (!customElements.get('v2-menu-accordions')) {
  customElements.define('v2-menu-accordions', V2MenuAccordions);
}
})();
